import { ConfigStateService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FidelityCardTypeCh } from '@proxy/cheetah/client/enum';
import { StorageService } from 'src/app/_services/storage.service';
import { FidelityCardDto } from 'src/publicproxy/src/proxy/dto-common-website/fidelity-card';
import { Router } from '@angular/router';
import { ImageService } from 'src/publicproxy/src/proxy/public/images';
import { MODAL, ModalService } from 'src/app/modals/modal.service';
import { CustomerDto } from '@proxy/dto-common-website/customers';
import { CustomerService } from 'src/publicproxy/src/proxy/public/customer';
import { InfoForHomeDto } from 'src/publicproxy/src/proxy/dto-common-website/images';
import { Context } from 'src/app/utils/context';
import { environment } from 'src/environments/environment';
import { UserStore } from 'src/app/store/user.store';
import { GTM } from 'src/app/_services/gtm.service';

@Component({
  selector: 'ng-casto-customer-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  FidelityCardTypeCh = FidelityCardTypeCh;
  cardInfos: FidelityCardDto;
  globalLoading: boolean = false;
  images: InfoForHomeDto;
  customerInfos: CustomerDto;
  copiedCode: string | null = null;
  public context: Context = Context.Customer;

  constructor(private customerService: CustomerService,
    public storageService: StorageService,
    private imageService: ImageService,
    public config: ConfigStateService,
    private modalService: ModalService,
    private router: Router,
    public userStore: UserStore,
    private gtm: GTM) { }

  ngOnInit() {
    this.globalLoading = true;
    this.customerService.getCustomer().subscribe({
      next: (e) => {
        this.customerInfos = e;
        if (e.cardNumber) {
          this.customerService.getFidelityCard().subscribe({
            next: (infos) => {
              e.cardNumber = infos.cardNumber;
              this.userStore.setUserCard(e);
              this.cardInfos = infos;
              this.globalLoading = false;
            }, error: () => {
              this.globalLoading = false;
            }
          });
        } else {
          this.router.navigate(['/creation/']);
        }
      },
      error: (err) => {
        console.error(err);
        this.globalLoading = false;
      }
    });

    this.imageService.getInfoForHome().subscribe((res) => {
      this.images = res;
    });
  }

  copyCode(code: string): void {
    navigator.clipboard.writeText(code).then(() => {
      this.copiedCode = code;
      setTimeout(() => this.copiedCode = null, 2000);
    });
  }

  displayRenewBtn(): boolean {

    let today = new Date();

    //Conversion de la date d'expiration en Date javascript
    let parts = this.cardInfos.finalExpirationDate.split('/');
    let expirationDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));

    let dateToNotice = new Date();

    //Ajout de la date de notification en fonction du setting
    dateToNotice.setTime(expirationDate.getTime() - (parseInt(this.config.getSetting('CastoramaFidelite.NbDaysNoticeEndSubscriptionPaidCard')) * 24 * 60 * 60 * 1000))

    return today > dateToNotice;
  }

  goToUpgradeCard() {
    this.gtm.trackInteraction("passage_max");
    this.router.navigate(['/creation/'], { queryParams: { upgrade: true } });
  }

  openModalCardInfo() {
    this.modalService.display(MODAL.CARD_INFOS, { type: FidelityCardTypeCh.Premium, context: this.context });
  }

  displayPremiumInfos(): boolean {
    return this.cardInfos?.type !== FidelityCardTypeCh.Premium && this.cardInfos?.type !== FidelityCardTypeCh.PremiumWaiting;
  }

  goToItem(type: string): void {
    const linkCGU = environment.links.cguUrl;
    const linkFAQ = "https://www.castorama.fr/relation-client/faq";
    const linkContact = "https://www.castorama.fr/services/contactez-nous";
    const linkCookies = "https://www.castorama.fr/notre-politique-cookies";
    switch (type) {
      case 'cgu':
        this.gtm.trackInteraction("outbound_click",
          "Conditions générales d'utilisation fidélité", { "target": linkCGU });
        window.open(linkCGU, '_blank').focus();
        break;
      case 'faq':
        this.gtm.trackInteraction("outbound_click",
          "FAQ", { "target": linkFAQ });
        window.open(linkFAQ, '_blank').focus();
        break;
      case 'contact':
        this.gtm.trackInteraction("outbound_click",
          "Nous contacter", { "target": linkContact });
        window.open(linkContact, '_blank').focus();
        break;
      case 'cookies':
        this.gtm.trackInteraction("outbound_click",
          "Données personnelles & cookies", { "target": linkCookies });
        window.open(linkCookies, '_blank').focus();
        break;
      default:
        break;
    }
  }
}
